/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBodyData;

  constructor(
    err: ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBodyData;

  constructor(
    err: ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBodyData;

  constructor(
    err: ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ExchangeApiKeyTokenAuthApiKeysResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ExchangeApiKeyTokenAuthApiKeysResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ExchangeApiKeyTokenAuthApiKeysResponseResponseBodyData;

  constructor(
    err: ExchangeApiKeyTokenAuthApiKeysResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ExchangeApiKeyTokenAuthApiKeysResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ExchangeApiKeyTokenAuthApiKeysResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ExchangeApiKeyTokenAuthApiKeysResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ExchangeApiKeyTokenAuthApiKeysResponseBodyData;

  constructor(
    err: ExchangeApiKeyTokenAuthApiKeysResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ExchangeApiKeyTokenAuthApiKeysResponseBody";
  }
}

/**
 * Bad request
 */
export type ExchangeApiKeyTokenResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ExchangeApiKeyTokenResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ExchangeApiKeyTokenResponseBodyData;

  constructor(
    err: ExchangeApiKeyTokenResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ExchangeApiKeyTokenResponseBody";
  }
}

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody
  > = z.instanceof(ExchangeApiKeyTokenAuthApiKeysResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody
  > = z.instanceof(ExchangeApiKeyTokenAuthApiKeysResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody
  > = z.instanceof(ExchangeApiKeyTokenAuthApiKeysResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponseResponseBody$inboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ExchangeApiKeyTokenAuthApiKeysResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ExchangeApiKeyTokenAuthApiKeysResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponseResponseBody$outboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ExchangeApiKeyTokenAuthApiKeysResponseResponseBody
  > = z.instanceof(ExchangeApiKeyTokenAuthApiKeysResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponseBody$inboundSchema:
  z.ZodType<ExchangeApiKeyTokenAuthApiKeysResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new ExchangeApiKeyTokenAuthApiKeysResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type ExchangeApiKeyTokenAuthApiKeysResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ExchangeApiKeyTokenAuthApiKeysResponseBody$outboundSchema:
  z.ZodType<
    ExchangeApiKeyTokenAuthApiKeysResponseBody$Outbound,
    z.ZodTypeDef,
    ExchangeApiKeyTokenAuthApiKeysResponseBody
  > = z.instanceof(ExchangeApiKeyTokenAuthApiKeysResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ExchangeApiKeyTokenResponseBody$inboundSchema: z.ZodType<
  ExchangeApiKeyTokenResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ExchangeApiKeyTokenResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ExchangeApiKeyTokenResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ExchangeApiKeyTokenResponseBody$outboundSchema: z.ZodType<
  ExchangeApiKeyTokenResponseBody$Outbound,
  z.ZodTypeDef,
  ExchangeApiKeyTokenResponseBody
> = z.instanceof(ExchangeApiKeyTokenResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
